import api from '@/api/api';

const resource = '/shops';

const state = {
  shop_id: null,
  shop_name: null,
  shop_key: null,
};

const getters = {
  SHOP_ID: (state) => state.shop_id,
};

const mutations = {
  SET_SHOP_ID: (state, payload) => {
    state.shop_id = payload;
    localStorage.setItem('shop_id', payload);
  },
  set_shop_name: (state, payload) => {
    state.shop_name = payload;
  },
  set_shop_key: (state, payload) => {
    state.shop_key = payload;
  },
};

const actions = {
  shops_create(context, payload) {
    api().post(`${resource}`, JSON.stringify(payload))
      .then((resp) => resp.data)
      .then((data) => context.commit('SET_SHOP_ID', data.id))
      .catch((error) => {
        console.error('Error:', error);
      });
  },

  shops_load(context) {
    api().get(`${resource}`)
      .then((resp) => resp.data)
      .then((data) => data.filter((shop) => Number(shop.id) === Number(context.state.shop_id))[0])
      .then((shop) => {
        context.commit('set_shop_name', shop.name);
        context.commit('set_shop_key', shop.amazon_key);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  },

  shops_edit(context, payload) {
    api().put(`${resource}`, JSON.stringify(payload))
      .then((resp) => resp.data)
      .then(() => context.dispatch('shops_load'))
      .catch((error) => {
        console.error('Error:', error);
      });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
